import { http, meetingHttp } from '@/server/meetHttpServer.js'
/* 获取语音转文字秘钥 */
export const getVoiceRecogKey = (data, type) => {
    let newrequest = type ? meetingHttp({ url: '/scavengerIm/voiceRecog/getVoiceRecogKey' }, data) : http({ url: '/scavengerIm/voiceRecog/getVoiceRecogKey' }, data)
    return newrequest
}

// 获取角色字典
export const searchDictionaryInfo = (data) => {
    return http({ url:'/gzzc/dictionary/searchDictionaryInfo'}, data)
}

// 查询案件人员角色
export const searchBizUserRole = (data) => {
    return http({url: '/gzzc/role/searchBizUserRole', method: 'post'}, data)
}

// 查询角色列表信息
export const listRole = (data) => {
    return http({url: '/pisces/role/listRole', method: 'post'}, data)
}

// 查询文书所有人信息
export const getMeetingPersonList = (data) => {
    return http({url: '/gzzc/trial/getMeetingPersonList', method: 'post'}, data)
}